import { RouteConfig } from 'vue-router';

import { legalRedirectGuard } from '@/router/guards';

import { PRIVACY_BASE_URL, TERMS_BASE_URL } from '@/config/external';

const Auth = () => import('@/views/auth/Auth.vue');
const AuthCallback = () => import('@/views/auth/AuthCallback.vue');
const AuthLink = () => import('@/views/auth/AuthLink.vue');

const Main = () => import('@/views/main/Main.vue');

export default [
  {
    path: '/',
    name: 'main',
    component: Main,
  },
  {
    path: '/township',
    name: 'township',
    beforeEnter() {
      window.location.href = 'https://playrix.com/games/township';
    },
  },
  {
    path: '/township/play',
    name: 'townshipPlay',
    beforeEnter() {
      window.location.href = 'https://playrix.com/games/township';
    },
  },
  {
    path: '/township/lp',
    name: 'townshipLandingPage',
    beforeEnter() {
      window.location.href = 'https://playrix.com/games/township';
    },
  },
  {
    path: '/township/lp1',
    name: 'townshipLandingPageV1',
    beforeEnter() {
      window.location.href = 'https://playrix.com/games/township';
    },
  },
  {
    path: '/township/lp4',
    name: 'townshipLandingPageV4',
    beforeEnter() {
      window.location.href = 'https://playrix.com/games/township';
    },
  },
  {
    path: '/township/lp5',
    name: 'townshipLandingPageV5',
    beforeEnter() {
      window.location.href = 'https://playrix.com/games/township';
    },
  },
  {
    path: '/homescapes',
    name: 'homescapes',
    beforeEnter() {
      window.location.href = 'https://playrix.com/games/homescapes';
    },
  },
  {
    path: '/homescapes/play',
    name: 'homescapesPlay',
    beforeEnter() {
      window.location.href = 'https://playrix.com/games/homescapes';
    },
  },
  {
    path: '/homescapes/lp',
    name: 'homescapesLandingPage',
    beforeEnter() {
      window.location.href = 'https://playrix.com/games/homescapes';
    },
  },
  {
    path: '/homescapes/lp/:variant',
    name: 'homescapesLandingPageVariant',
    beforeEnter() {
      window.location.href = 'https://playrix.com/games/homescapes';
    },
  },
  {
    path: '/homescapes/game',
    name: 'homescapesGame',
    beforeEnter() {
      window.location.href = 'https://playrix.com/games/homescapes';
    },
  },
  {
    path: '/play',
    name: 'play',
    beforeEnter() {
      window.location.href = 'https://playrix.com/games/homescapes';
    },
  },
  {
    path: '/game',
    name: 'game',
    beforeEnter() {
      window.location.href = 'https://playrix.com/games/homescapes';
    },
  },
  {
    path: '/auth',
    name: 'auth',
    component: Auth,
    meta: { requiresAnon: true },
  },
  {
    path: '/auth/callback',
    name: 'authCallback',
    component: AuthCallback,
    props: ({ query }) => ({
      code: query.code,
      state: query.state,
      scope: query.scope,
    }),
    meta: { requiresAnon: true },
  },
  {
    path: '/auth/link',
    name: 'authLink',
    component: AuthLink,
    props: ({ query }) => ({
      token: query.token,
    }),
    meta: { requiresAuth: true },
  },
  {
    path: '/auth/blank',
    name: 'authBlank',
    beforeEnter(to, from, next) {
      return next({ name: 'main' });
    },
  },
  {
    path: '/privacy',
    name: 'privacy',
    beforeEnter: legalRedirectGuard,
    meta: {
      redirect: PRIVACY_BASE_URL,
    },
  },
  {
    path: '/terms',
    name: 'terms',
    beforeEnter: legalRedirectGuard,
    meta: {
      redirect: TERMS_BASE_URL,
    },
  },
  {
    path: '*',
    redirect: { name: 'main' },
  },
] as Array<RouteConfig>;
